export default {
  //* pages
  PAGE_ABOUT_RPA: 'pageAboutRpa',
  PAGE_PRODUCT: 'pageProduct',
  PAGE_SOLUTIONS: 'pageSolutions',
  PAGE_NEWSROOM_ARTICLE: 'pageNewsroomArticle',
  PAGE_RESOURCE: 'pageResource',
  PAGE_RESOURCE_DEMO: 'pageResourceDemo',
  PAGE_WEBINAR_RECORDING: 'pageWebinarRecording',
  PAGE_WHITEPAPER: 'pageWhitePaper',
  PAGE_ANALYST_REPORT: 'pageAnalystReport',
  PAGE_PLACEHOLDER: 'pagePlaceholder',
  PAGE_EVENTS: 'pageEvents',
  PAGE_BROCHURE: 'pageBrochure',
  PAGE_FLEX: 'pageFlex',
  PAGE_FORM_FLEX: 'pageFormFlex',
  PAGE_BLOG_POST: 'pageBlogPost',
  PAGE_SECONDARY_BLOG_POST: 'pageSecondaryBlogPost',
  PAGE_MAIN_BLOG: 'pageMainBlog',
  PAGE_BLOG_AUTHOR_LISTING: 'pageBlogAuthorListing',
  PAGE_BLOG_CATEGORY_LISTING: 'pageBlogCategoryListing',
  PAGE_BLOG_COLLECTION_LISTING: 'pageBlogCollectionListing',
  PAGE_RAW_HTML: 'pageRawHtml',
  PAGE_AGENCY_TEST: 'pageAgencyTest',
  HOMEPAGE: 'homepage',
  PAGE_PDF: 'wrapperPdf',
  PAGE_PARTNER_POST: 'pagePartner',
  PAGE_TECHNOLOGY_ALLIANCES: 'pageTechnologyAlliances',
  PAGE_BUSINESS_PARTNERS: 'pageBusinessPartners',
  PAGE_SERVICE_PARTNERS: 'pageServicePartners',
  PAGE_PUBLIC_SECTOR_PARTNERS: 'pagePublicSectorPartners',
  PAGE_CAREER: 'pageCareer',
  PAGE_DOWNLOAD: 'pageDownload',
  PAGE_THANK_YOU: 'pageThankYou',
  PAGE_LEGAL: 'pageLegal',
  PAGE_COMPANY_LISTING: 'pageCompanyListing',
  PAGE_RESOURCE_LISTING: 'pageResourceListing',

  //* components
  COMPONENT_HERO: 'componentHero',
  COMPONENT_FEATURED_SLIDER: 'componentFeaturedSlider',
  COMPONENT_BLOG_FEATURED_RESOURCE: 'componentBlogFeaturedResource',
  COMPONENT_SUBSCRIBE: 'componentSubscribe',
  COMPONENT_ANNOUNCEMENT: 'componentAnnouncement',
  COMPONENT_TAB_ORDER: 'componentTabOrder',
  COMPONENT_TEASER: 'teaser', //* external resource
  COMPONENT_MAIN_NAV_BANNER: 'componentMainNavBanner',
  COMPONENT_MARKETO_FORM: 'componentMarketoForm',
  COMPONENT_BOILERPLATE: 'componentBoilerplate',
  COMPONENT_BIO: 'componentBio',
  COMPONENT_TYFR: 'componentThankYouFeaturedResource',
  COMPONENT_CONTENT_ROW: 'componentContentRows',
  COMPONENT_QUOTE: 'componentQuote',
  COMPONENT_TABLE: 'componentTable',

  //* topics
  TOPIC_CUSTOMER_DETAIL: 'topicCustomerDetails',
  TOPIC_ANCHOR_LINK: 'topicAnchorLink',
  TOPIC_CTA: 'topicCta',
  TOPIC_ICON_LINK: 'topicIconLink',

  //* wrappers/menu/microcopy
  MICROCOPY_SET: 'microcopySet',
  NAV_MENU: 'navMenu',
  WRAPPER_ASSET: 'WrapperAsset',
  WRAPPER_VIDEO: 'wrapperVideo',
}
